// TRANSPARENT HEADER - UNIQUE NAMESPACE
(function() {
  'use strict';
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTransparentHeader);
  } else {
    initTransparentHeader();
  }
  
  function initTransparentHeader() {
    const toggle = document.getElementById('menuToggleUnique');
    const overlay = document.getElementById('menuOverlayUnique');
    const menuImage = document.getElementById('menuImageUnique');
    const placeholder = document.querySelector('.image-placeholder-unique');
    const items = document.querySelectorAll('.menu-item-unique');
    const headerWrap = document.querySelector('.transparent-header-unique');
    const defaultImage = headerWrap?.dataset?.defaultImage || '';
    const isHomepage = headerWrap && headerWrap.classList.contains('header--homepage');

    if (!toggle || !overlay) return;

    let imageTimeout;
    let isAnimating = false;

    // HOVER EFFECT VARIABLES
    const logoHover = document.getElementById('logoHoverUnique');
    const hamburgerHover = document.getElementById('hamburgerHoverUnique');
    let isLogoHovering = false;
    let isHamburgerHovering = false;
    let mouseX = 0;
    let mouseY = 0;
    let logoX = 0;
    let logoY = 0;
    let hamburgerX = 0;
    let hamburgerY = 0;

    document.addEventListener('mousemove', (e) => {
      mouseX = e.clientX;
      mouseY = e.clientY;
      if (isLogoHovering && logoHover) updateLogoPosition();
      if (isHamburgerHovering && hamburgerHover) updateHamburgerPosition();
    });

    if (logoHover) {
      logoHover.addEventListener('mouseenter', () => {
        isLogoHovering = true;
        logoHover.style.transition = 'transform 0.2s cubic-bezier(0.175, 0.885, 0.32, 1.275)';
      });
      logoHover.addEventListener('mouseleave', () => {
        isLogoHovering = false;
        logoHover.style.transition = 'transform 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)';
        logoHover.style.transform = 'translate(0, 0)';
        logoX = 0; logoY = 0;
      });
    }

    if (hamburgerHover) {
      hamburgerHover.addEventListener('mouseenter', () => {
        isHamburgerHovering = true;
        hamburgerHover.style.transition = 'transform 0.2s cubic-bezier(0.175, 0.885, 0.32, 1.275)';
      });
      hamburgerHover.addEventListener('mouseleave', () => {
        isHamburgerHovering = false;
        hamburgerHover.style.transition = 'transform 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)';
        hamburgerHover.style.transform = 'translate(0, 0)';
        hamburgerX = 0; hamburgerY = 0;
      });
    }

    function updateLogoPosition() {
      if (!logoHover || !isLogoHovering) return;
      const logoRect = logoHover.getBoundingClientRect();
      const deltaX = mouseX - (logoRect.left + logoRect.width / 2);
      const deltaY = mouseY - (logoRect.top + logoRect.height / 2);
      const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
      const normalizedDistance = Math.min(distance / Math.max(logoRect.width, logoRect.height), 1);
      const moveX = deltaX * 0.15 * normalizedDistance;
      const moveY = deltaY * 0.15 * normalizedDistance;
      logoX += (moveX - logoX) * 0.3;
      logoY += (moveY - logoY) * 0.3;
      logoHover.style.transform = `translate(${Math.max(Math.min(logoX, 10), -10)}px, ${Math.max(Math.min(logoY, 10), -10)}px)`;
    }

    function updateHamburgerPosition() {
      if (!hamburgerHover || !isHamburgerHovering) return;
      const rect = hamburgerHover.getBoundingClientRect();
      const deltaX = mouseX - (rect.left + rect.width / 2);
      const deltaY = mouseY - (rect.top + rect.height / 2);
      const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
      const normalizedDistance = Math.min(distance / Math.max(rect.width, rect.height), 1);
      const moveX = deltaX * 0.2 * normalizedDistance;
      const moveY = deltaY * 0.2 * normalizedDistance;
      hamburgerX += (moveX - hamburgerX) * 0.3;
      hamburgerY += (moveY - hamburgerY) * 0.3;
      hamburgerHover.style.transform = `translate(${Math.max(Math.min(hamburgerX, 15), -15)}px, ${Math.max(Math.min(hamburgerY, 15), -15)}px)`;
    }

    function animate() {
      if (isLogoHovering && logoHover) updateLogoPosition();
      if (isHamburgerHovering && hamburgerHover) updateHamburgerPosition();
      requestAnimationFrame(animate);
    }
    animate();

    // Force homepage header background transparent always
    function enforceHomepageTransparency() {
      if (!isHomepage) return;
      if (headerWrap) headerWrap.style.removeProperty('background');
      const innerHeader = headerWrap.querySelector('header.transparent-header-unique');
      if (innerHeader) innerHeader.style.removeProperty('background');
    }

    // MENU TOGGLE
    toggle.addEventListener('click', () => {
      if (isAnimating) return;
      const isActive = toggle.classList.contains('active');

      if (!isActive) {
        isAnimating = true;
        if (isLogoHovering) { isLogoHovering = false; if (logoHover) { logoHover.style.transform = 'translate(0, 0)'; logoX = 0; logoY = 0; } }
        if (isHamburgerHovering) { isHamburgerHovering = false; if (hamburgerHover) { hamburgerHover.style.transform = 'translate(0, 0)'; hamburgerX = 0; hamburgerY = 0; } }
        toggle.classList.add('active');
        overlay.classList.add('active');
        document.body.style.overflow = 'hidden';
        if (defaultImage) {
          clearTimeout(imageTimeout);
          menuImage.classList.remove('active');
          imageTimeout = setTimeout(() => {
            menuImage.src = defaultImage;
            if (placeholder) placeholder.classList.add('hidden');
            setTimeout(() => { menuImage.classList.add('active'); }, 50);
          }, 400);
        }
        setTimeout(() => { isAnimating = false; }, 800);
      } else {
        isAnimating = true;
        overlay.classList.remove('active');
        toggle.classList.remove('active');
        document.body.style.overflow = '';
        setTimeout(() => { isAnimating = false; }, 800);
      }
    });

    items.forEach(item => {
      item.addEventListener('mouseenter', () => {
        clearTimeout(imageTimeout);
        const img = item.dataset.image;
        const hasImage = item.dataset.hasImage === 'true';
        if (hasImage && img) {
          menuImage.classList.remove('active');
          imageTimeout = setTimeout(() => {
            menuImage.src = img;
            if (placeholder) placeholder.classList.add('hidden');
            setTimeout(() => { menuImage.classList.add('active'); }, 50);
          }, 200);
        } else {
          menuImage.classList.remove('active');
          imageTimeout = setTimeout(() => {
            if (defaultImage) menuImage.src = defaultImage;
            if (placeholder) placeholder.classList.remove('hidden');
            setTimeout(() => { menuImage.classList.add('active'); }, 50);
          }, 200);
        }
      });
    });

    const menuContainer = document.querySelector('.menu-items-container-unique');
    if (menuContainer) {
      menuContainer.addEventListener('mouseleave', () => {
        clearTimeout(imageTimeout);
        if (defaultImage) {
          menuImage.classList.remove('active');
          imageTimeout = setTimeout(() => {
            menuImage.src = defaultImage;
            if (placeholder) placeholder.classList.add('hidden');
            setTimeout(() => { menuImage.classList.add('active'); }, 50);
          }, 300);
        }
      });
    }

    overlay.addEventListener('click', (e) => {
      if (e.target === overlay && !isAnimating) {
        isAnimating = true;
        overlay.classList.remove('active');
        toggle.classList.remove('active');
        document.body.style.overflow = '';
        setTimeout(() => { isAnimating = false; }, 800);
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && overlay.classList.contains('active') && !isAnimating) {
        isAnimating = true;
        overlay.classList.remove('active');
        toggle.classList.remove('active');
        document.body.style.overflow = '';
        setTimeout(() => { isAnimating = false; }, 800);
      }
    });

    window.addEventListener('load', () => {
      toggle.classList.remove('active');
      overlay.classList.remove('active');
      document.body.style.overflow = '';
      isAnimating = false;
      enforceHomepageTransparency();
    });

    // SCROLL HIDE/SHOW
    const header = document.querySelector('.transparent-header-unique > header.transparent-header-unique');
    if (!header) return;

    let lastScrollTop = 0;
    const scrollThreshold = 10;
    const headerHeight = header.offsetHeight;
    let ticking = false;
    let isHeaderHidden = false;

    window.addEventListener('scroll', () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

          // Always enforce transparent on homepage — remove any inline bg that theme JS may set
          enforceHomepageTransparency();

          if (!overlay.classList.contains('active')) {
            if (scrollTop > lastScrollTop && scrollTop > headerHeight && !isHeaderHidden) {
              if (Math.abs(scrollTop - lastScrollTop) > scrollThreshold) {
                header.style.transform = `translateY(-${headerHeight}px)`;
                isHeaderHidden = true;
              }
            } else if (scrollTop < lastScrollTop && isHeaderHidden) {
              if (Math.abs(scrollTop - lastScrollTop) > scrollThreshold) {
                header.style.transform = 'translateY(0)';
                isHeaderHidden = false;
              }
            }
            if (scrollTop <= 10) {
              header.style.transform = 'translateY(0)';
              isHeaderHidden = false;
            }
          } else {
            header.style.transform = 'translateY(0)';
            isHeaderHidden = false;
          }

          lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });

    window.addEventListener('resize', () => {
      if (!overlay.classList.contains('active')) {
        header.style.transform = 'translateY(0)';
        isHeaderHidden = false;
      }
    });
  }
})();
